import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index'
import Login from '@/view/login'
import Shitang from '@/view/shitang'
// import Statistics from '@/view/statistics'
import nStatistics from '@/view/nStatistics'
import mingChu from '../view/mingChu'
// import MapIndex from '@/view/mapIndex'
import Test from '@/view/test'

Vue.use(Router)


/**
 * @description: 将组件字符串路径转换为异步组件
 * @author: linwen linwen@fjxhx.com
 * @createDate: 2020-10-22 17:26
 * @param: {string} component 组件的字符串路径
 * @return: {function(): Promise<Result> | Promise<any>}
 */
export function lazyLoading(component) {
  return () => import(`@/view/${component}`).catch(error => {
    // 后端传递了一个错误的组件地址
    console.log(`接收了一个无效的组件地址：'${component}', ${error}`)
    return import('@/view/404')
  })
}

/**
 * 基础路由 (没有权限要求的基础页面,(登录页和个人账户信息以及重定向路由))
 */
export const constantRoutes = [
    // {
    //   path: '/',
    //   name: 'Index',
    //   // component: Index,
    //   component: resolve => require(['@/view/index'], resolve), // 首页懒加载
    //   meta: {
    //     keepAlive: false,
    //     title: '首页',
    //     type: 'login' // 是否需要判断是否登录,这里是需要判断
    //   }
    // },
    // {
    //   path: '/index',
    //   name: 'Index1',
    //   component: Index,
    //   meta: {
    //     keepAlive: false,
    //     title: '首页',
    //     type: 'login' // 是否需要判断是否登录,这里是需要判断
    //   }
    // },
    // {
    //   path: '/map',
    //   name: 'MapIndex',
    //   component: MapIndex,
    //   meta: {
    //     keepAlive: false,
    //     title: '地图首页',
    //     type: 'login' // 是否需要判断是否登录,这里是需要判断
    //   }
    // },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        keepAlive: false,
        title: '登录',
        type: '' // 是否需要判断是否登录,这里是需要判断
      }
    },
    {
      path: '/Shitang',
      name: 'Shitang',
      component: Shitang,
      meta: {
        keepAlive: false,
        title: '食堂详情',
        type: 'login' // 是否需要判断是否登录,这里是需要判断
      }
    },
    // {
    //   path: '/statistics',
    //   name: 'Statistics',
    //   component: Statistics,
    //   meta: {
    //     keepAlive: true,
    //     title: '统计分析页',
    //     type: 'login' // 是否需要判断是否登录,这里是需要判断
    //   }
    // },
    // {
    //   path: '/nStatistics',
    //   name: 'nStatistics',
    //   component: nStatistics,
    //   meta: {
    //     keepAlive: true,
    //     title: '大数据统计',
    //     type: 'login' // 是否需要判断是否登录,这里是需要判断
    //   }
    // },
    // {
    //   path: '/mingChu',
    //   name: 'mingChu',
    //   component: mingChu,
    //   meta: {
    //     keepAlive: false,
    //     title: '明厨亮灶',
    //     type: 'login' // 是否需要判断是否登录,这里是需要判断
    //   }
    // },
    {
      path: '/jidaIndex',
      name: 'jidaIndex',
      component: Index,
      meta: {
        keepAlive: false,
        title: '首页',
        type: 'login' // 是否需要判断是否登录,这里是需要判断
      }
    },
    {
      path: '/jidaMingChu',
      name: 'jidaMingChu',
      component: mingChu,
      meta: {
        keepAlive: true,
        title: '大数据统计',
        type: 'login' // 是否需要判断是否登录,这里是需要判断
      }
    },
    {
      path: '/jidaStatistics',
      name: 'jdStatistics',
      component: nStatistics,
      meta: {
        keepAlive: true,
        title: '大数据统计',
        type: 'login' // 是否需要判断是否登录,这里是需要判断
      }
    },
    {
      path: '/test',
      name: 'Test',
      component: Test,
      meta: {
        keepAlive: false,
        title: '测试',
        type: 'login' // 是否需要判断是否登录,这里是需要判断
      }
    }
  ]


const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js